module.exports = __webpack_public_path__ + "c7f7d0f3d27d57b39a199973b9b17bf3.pdf";